import { use, useState } from 'react';
import axios from 'axios';
import {jwtDecode} from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';
import { resetUser, setItoken, setRole, setToken, setUsername } from '../slice/userSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import useUser from './useUser';
import { setRoleList } from '../slice/generalSettingSlice';
//import { useLogout } from './useLogout';
//import { useSelector } from 'react-redux';


const useLogin = () =>{
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [resetLoading, setResetLoading] = useState(false);

    const HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const token = useSelector((state)=>state.user.itoken);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {getRoles} = useUser();

    const login = async(userData,onSuccess,onError,onFirstLogin) =>{
        // const headers = {
        //     Accept: "application/json",
        //     "Content-Type": "application/x-www-form-urlencoded",
        //     Authorization: `Basic ${btoa("client:")}`,
        // };
        // const body = new URLSearchParams();
        // body.set("grant_type", "password");
        // body.set("username", userData.username);
        // body.set("password", userData.password);

      const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
        'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        };

      try {
        setLoading(true);

        axios.post(
            `${HOST}/public/auth/login`,
            {
                username: userData.username,
                password: userData.password,
            },
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                let decoded = jwtDecode(response.data.innToken);
                if(["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"].some(e=> decoded?.role)){
                    if(response.data.passwordReset){
                      dispatch(setItoken(response.data.innToken));
                      onFirstLogin();
                    }else{
                      dispatch(setToken(response.data.uwbToken));
                      dispatch(setItoken(response.data.innToken))
                      dispatch(setUsername(decoded.user_name));
                      dispatch(setRole(decoded.role));
                      getRoles(
                          (data)=>{
                              dispatch(setRoleList(data));
                          },
                          ()=>{
                              toast.error("Errore nel ricevere i ruoli");
                          },
                          response.data.innToken
                      );

                      onSuccess();
                    }
                }else{
                    toast.error("impossibile accedere");
                }
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const firstResetPassword = async(passwordData,onSuccess,onError) =>{
      const headers = {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
        'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
      };
      try {
        setResetLoading(true);
        
        axios.patch(
            `${HOST}/api/v1/users/password`,
            passwordData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess();
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setResetLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }
    }

    const logout = () => {
      dispatch(resetUser());
      navigate('/login');
      window.location.reload();
    };


    return { login, firstResetPassword, logout, loading, resetLoading, error };
};

export default useLogin;